<template>
  <el-main>
    <div class="container">
      <el-breadcrumb separator="/" class="common-nav">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/user/course' }">我的课程</el-breadcrumb-item>
        <el-breadcrumb-item>{{ study.title }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ course ? course.title : '该科目已被删除' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="study-detail">
            <img
                :src="study.images && study.images.length > 0 ? path + study.images[0] : noneImg"
                :alt="study.title || '该班型已被删除'" class="study-img">
            <div class="study-title">
              {{ study.title || '该班型已被删除' }}
            </div>
            <div class="course-title" v-if="course">
              {{ course.title || '该科目已被删除' }}
            </div>
            <div class="study-time">
              购买时间：{{ info.created_at }}
            </div>
            <!--            <div class="study-time">-->
            <!--              有效期至：{{ study.end_time }}-->
            <!--            </div>-->
            <div class="study-agreement" v-if="study.agreement_id && info.rebuild === 0">
              <el-button v-if="info.status === 0" size="mini" type="danger" @click="agreeAgreement">签署协议</el-button>
              <el-button v-if="info.status === 1" size="mini" type="success" @click="dialogAgreement = true">查看协议
              </el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="study-box">
            <div class="study-nav">
              <div class="study-nav-list">
                <div class="study-nav-item" v-for="(item, index) in nav" :key="index"
                     :class="[navActive === item.id ? 'current' : '']" @click="changeNav(item.id)">
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="study-body" v-loading="loading">
              <div class="study-list" v-if="papers.length > 0 && navActive === 1">
                <div class="study-item" v-for="(item, index) in papers" :key="index"
                     @click="goTest(item.paper ? item.paper.id : 0)">
                  <div class="study-item-title">
                    <span v-if="item.last_at" class="paper-label paper-success">已做</span>
                    <span v-if="!item.last_at" class="paper-label paper-error">未做</span>
                    <span>{{ item.paper ? item.paper.title : '该试卷不存在或已删除' }}</span>
                  </div>
                  <div class="el-icon-arrow-right"></div>
                </div>
              </div>
              <div class="study-list" v-if="videos.length > 0 && navActive === 2">
                <div class="study-item" v-for="(item, index) in videos" :key="index" @click="goVideo(item.video_id)">
                  <div class="study-item-title">
                    {{ item.video ? item.video.title : '该视频不存在或已删除' }}
                  </div>
                  <div class="el-icon-arrow-right"></div>
                </div>
              </div>
              <div class="study-list" v-if="navActive === 3">
                <div v-html="outline && outline.body" class="outline"></div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="协议" :visible.sync="dialogAgreement">
      <div class="agreement-box" v-if="study && study.agreement && course">
        <div class="agreement-title">
          {{ study.agreement.title }}
        </div>
        <div class="agreement-info">
          <div class="agreement-p">
            <div>甲方：上海源学网科技发展有限公司</div>
            <div>乙方：{{ identity.name }}</div>
          </div>
          <div class="agreement-p">
            <div>联系电话：400-065-6688</div>
            <div>联系电话：{{ user.phone }}</div>
          </div>
          <div class="agreement-p">
            <div></div>
            <div>身份证号码：{{ identity.idcard }}</div>
          </div>
        </div>
        <div class="agreement-study">
          <p class="agreement-bold">产品相关内容</p>
          <p>购买班型：{{ study.title }}</p>
          <p>科目：{{ course.title }}</p>
          <p v-if="info.a_price > 0">金额：{{ info.a_price }}元</p>
          <p>交付方式：网站在线交付、微信小程序</p>
          <p>服务期限：{{ info.created_at }}至考试结束后3日内</p>
        </div>
        <div class="agreement-study">
          <p class="agreement-bold">协议正文</p>
          <div class="agreement-body" v-html="study.agreement.body"></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="info.status === 0">
        <el-button type="danger" @click="dialogAgreement = false">拒绝</el-button>
        <el-button type="primary" @click="agree" v-loading.fullscreen.lock="fullscreenLoading">同意</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import {authRequest} from "@/utils/request";
import {mapGetters} from "vuex";

export default {
  name: "studyIndex",
  head() {
    return {
      title: this.study.title ? this.study.title : '课程详情'
    }
  },
  data() {
    return {
      id: 0,
      study: '',
      course: '',
      path: process.env.VUE_APP_FILE,
      noneImg: process.env.VUE_APP_NONE,
      nav: [{
        title: '试卷',
        id: 1
      }, {
        title: '视频',
        id: 2
      }, {
        title: '大纲',
        id: 3
      }],
      navActive: 1,
      loading: false,
      papers: [],
      videos: [],
      info: '',
      identity: '',
      dialogAgreement: false,
      fullscreenLoading: false,
      outline: '',
      white: null
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  created() {
    this.id = this.$route.params.id
    this.getStudy()
    this.getIdentity()
  },
  methods: {
    async getStudy() {
      this.loading = true
      try {
        let response = await authRequest('user/study/' + this.id, {
          method: 'GET'
        })
        this.study = response.data.course.study
        this.course = response.data.course.course
        this.papers = response.data.papers
        this.videos = response.data.videos
        this.info = response.data.course
        this.white = response.data.white
        this.outline = response.data.outline

        if (this.videos.length <= 0) {
          let index = this.nav.findIndex(item => item.id === 2)
          this.nav.splice(index, 1)
        }

        if (!this.outline) {
          let index = this.nav.findIndex(item => item.id === 3)
          this.nav.splice(index, 1)
        }

        this.loading = false
      } catch (e) {
        if (e.response) {
          if (e.response.status === 404) {
            this.$router.push('/error/404')
          }
        }
      }
    },
    async getIdentity() {
      try {
        let response = await authRequest('user/identification', {
          method: 'GET'
        })
        this.identity = response.data.data
      } catch (e) {
        this.identity = '请先完成实名认证'
      }
    },
    changeNav(index) {
      this.navActive = index
      // if (index === 3) {
      //   this.getOutline()
      // }
    },
    goVideo(id) {
      if (this.study.agreement_id && this.info.status === 0 && !this.white && this.info.rebuild === 0) {
        this.$message.warning('您还没有签署协议，请先签署协议')
        return false
      }
      this.$router.push({path: '/video/' + id})
    },
    goTest(id) {
      if (this.study.agreement_id && this.info.status === 0 && !this.white && this.info.rebuild === 0) {
        this.$message.warning('您还没有签署协议，请先签署协议')
        return false
      }
      if (!id) {
        this.$message.error('该试卷不存在或已删除')
        return false
      }
      this.$router.push({path: '/test/' + id})
    },
    async agreeAgreement() {
      if (this.identity.status !== 1) {
        this.$message.error('请先完成实名认证')
        this.$router.push({path: '/user'})
        return false
      }
      this.dialogAgreement = true
    },
    async agree() {
      this.fullscreenLoading = true
      try {
        let response = await authRequest('study/agreement', {
          method: 'POST',
          data: {
            id: this.info.id
          }
        })
        if (response.status === 203) {
          this.fullscreenLoading = false
          this.dialogAgreement = false
          this.$message.success('协议签署完成，您可以开始学习啦～')
          this.getStudy()
        }
      } catch (e) {

      }
    },
    async getOutline() {
      try {
        let response = await authRequest('study/outline/course', {
          method: 'GET',
          params: {
            study_id: this.study.id,
            course_id: this.course.id
          }
        })
        this.outline = response.data.data
      } catch (e) {

      }
    }
  }
}
</script>

<style scoped>
.study-detail {
  background-color: #ffffff;
  padding: 15px;
  border-radius: 5px;
}

.study-img {
  width: 100%;
  border-radius: 5px;
  height: 160px;
  object-fit: cover;
}

.study-title {
  margin-top: 5px;
  font-weight: 400;
}

.course-title {
  font-size: 13px;
  color: #666666;
}

.study-time {
  margin-top: 5px;
  font-size: 13px;
}

.study-box {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 15px;
}

.study-nav {
  display: flex;
  justify-content: center;
}

.study-nav-list {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.study-nav-item {
  width: 100px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border: 1px solid #ebebeb;
  cursor: pointer;
  font-size: 16px;
}

.study-nav-item:nth-child(2) {
  border-left: 0;
}

.study-nav-item:nth-child(3) {
  border-left: 0;
}

.study-nav-item.current {
  background-color: #2aacb2;
  border-color: #2aacb2;
  color: #ffffff;
}

.study-body {
  margin-top: 30px;
  min-height: 300px;
}

.study-item {
  display: flex;
  justify-content: space-between;
  height: 40px;
  align-items: center;
  border: 1px dashed #ebebeb;
  margin-bottom: 10px;
  padding: 0 15px;
  cursor: pointer;
}

.study-item:hover {
  color: #2aacb2;
}

.study-agreement {
  margin-top: 20px;
  text-align: center;
}

.agreement-title {
  font-size: 16px;
  color: #444;
  font-weight: bold;
  text-align: center;
}

.agreement-info {
  margin-top: 20px;
}

.agreement-p {
  display: flex;
  justify-content: space-between;
}

.agreement-p div {
  width: 48%;
}

.agreement-study {
  margin-top: 20px;
}

.agreement-bold {
  font-weight: bold;
}

.paper-label {
  margin-right: 10px;
  padding: 2px 5px;
  border-radius: 3px;
  color: #ffffff;
  font-size: 12px;
}

.paper-success {
  background-color: #67C23A;
}

.paper-error {
  background-color: #F56C6C;
}
</style>
